import { c as _c } from "react/compiler-runtime";
import { Button } from '@chakra-ui/react';
import { useAdvisorsAttention } from '@src/components/sco/Advisors/hooks/useAdvisorsAttention';
import { advisorsBreadcrumbsWithTrail, useAdvisorsToolbar } from '@src/components/sco/Advisors/hooks/useAdvisorsToolbar';
import { AdvisorsSubNavLayout } from '@src/components/sco/Advisors/layout/AdvisorsSubNavLayout';
import { useAdvisorsPaths } from '@src/components/sco/Advisors/paths';
import { acceptingSessionsDirectoryHref } from '@src/components/sco/Advisors/utils/directoryFilters';
import { sessionsNavItems, SessionsSectionKey } from '@src/components/sco/Advisors/utils/sessionsNav';
import { NextLink } from '@src/components/sco/utilities/NextLink';
import { ReactNode } from 'react';
import { LuCalendarPlus } from 'react-icons/lu';

/**
 * Sessions shell — sub-nav rail plus section content.
 *
 * Bucket views (All / Needs action / Upcoming / Past) are the list filters.
 * Needs action carries the your-turn count (W3, L25): sessions whose proposed times wait on the
 * viewer, plus `pending` sessions for both parties. The bucket list itself is unchanged.
 * Book a Session is the rail CTA and opens the directory with the
 * accepting-sessions filter on. Rates and payouts live under My Advisor Profile.
 */
export const SessionsLayout = t0 => {
  const $ = _c(18);
  const {
    activeKey,
    title,
    description,
    action,
    children
  } = t0;
  const paths = useAdvisorsPaths();
  const {
    attention
  } = useAdvisorsAttention();
  const navItems = sessionsNavItems(paths);
  let t1;
  if ($[0] !== activeKey) {
    t1 = item => item.key === activeKey;
    $[0] = activeKey;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const activeItem = navItems.find(t1);
  const isBucketView = activeKey === "all" || activeKey === "action" || activeKey === "upcoming" || activeKey === "past";
  useAdvisorsToolbar({
    breadcrumbs: isBucketView && activeKey === "all" ? advisorsBreadcrumbsWithTrail({
      title: "My sessions",
      href: paths.sessions
    }) : advisorsBreadcrumbsWithTrail({
      title: "My sessions",
      href: paths.sessions
    }, {
      title: activeItem?.title ?? "Sessions",
      href: activeItem?.href ?? paths.sessions
    })
  });
  const T0 = AdvisorsSubNavLayout;
  const t2 = "Paid video sessions with marketplace advisors.";
  const t3 = "Sessions";
  let t4;
  if ($[2] !== attention) {
    t4 = item_0 => ({
      key: item_0.key,
      title: item_0.title,
      href: item_0.href,
      icon: item_0.icon,
      attentionCount: item_0.key === "action" ? attention.sessionsNeedingAction : undefined
    });
    $[2] = attention;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = navItems.map(t4);
  let t6;
  if ($[4] !== paths) {
    t6 = acceptingSessionsDirectoryHref(paths);
    $[4] = paths;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <LuCalendarPlus />;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== t6) {
    t8 = <Button asChild={true} size="sm" variant="cta" width="full"><NextLink href={t6}>{t7} Book a Session</NextLink></Button>;
    $[7] = t6;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== T0 || $[10] !== action || $[11] !== activeKey || $[12] !== children || $[13] !== description || $[14] !== t5 || $[15] !== t8 || $[16] !== title) {
    t9 = <T0 action={action} activeKey={activeKey} description={description} railDescription={t2} railTitle={t3} title={title} items={t5} railFooter={t8}>{children}</T0>;
    $[9] = T0;
    $[10] = action;
    $[11] = activeKey;
    $[12] = children;
    $[13] = description;
    $[14] = t5;
    $[15] = t8;
    $[16] = title;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  return t9;
};